export default {
  no_mobile_app: 'Nicio aplicație mobilă configurată',
  mobile_app_not_live: 'Aplicația mobilă nu este activă',
};
